module.exports = __webpack_public_path__ + "static/media/cat-9.7cc26d82.jpg";